import { PushRoute } from 'generated/graphql';

export const pushRoutes = [
  { name: 'Главный экран', id: PushRoute.Home },
  { name: 'Промо', id: PushRoute.Promo },
];
